import React from "react";
import Header from "../../../../ui-components/LandingPage/ExactnessUi/Header";
import TestimonialOne from "../../../../ui-components/LandingPage/ExactnessUi/TestimonialOne";
import TestimonialTwo from "../../../../ui-components/LandingPage/ExactnessUi/TestimonialTwo";
import Context from "../../../../ui-components/LandingPage/ExactnessUi/Context";
import Table from "../../../../ui-components/LandingPage/ExactnessUi/Table";

const Exactness = () => {
  return (
    <>
      {/* <div className="min-[2000px]:px-36"> */}
      <Header />
      <TestimonialOne />
      <TestimonialTwo />
      <Table />
      <Context />
      {/* </div> */}
    </>
  );
};

export default Exactness;